// @flow
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../components/auth/auth.service';
import { Subscription } from 'rxjs';
import { UtilityService } from '../../shared/services/Utility.service';
import { AppServiceService } from '../../main/services/product.service';
import Swal from 'sweetalert2';

/* interface User {
    name: string;
    email: string;
    password: string;
} */

@Component({
    selector: 'forgotpassword',
    template: require('./forgotpassword.html'),
})

export class ForgotPasswordComponent implements OnInit {
  /*   user: User = {
        name: '',
        email: '',
        password: ''
    }; */
   // isCollapsed = true;
    /* menu = [{
        title: 'forgotpassword',
        'link': '/forgotpassword',
    }]; */
    errors: {field?: Error} = {};
   //submitted = false;
    AuthService;
    Router;
    isLoggedIn;

    public forgotPassword: any;
    busy: Subscription;
    selectedUser: any;
    selectedUserPass: any;
    logintype: any;

    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    static parameters = [AuthService, Router, HttpClient, ActivatedRoute, UtilityService, AppServiceService];
    constructor(_AuthService_: AuthService, router: Router, private http: HttpClient, private route: ActivatedRoute, private _UtilityService: UtilityService, private _AppServiceService: AppServiceService) {
        this.AuthService = _AuthService_;
        this.Router = router;
        this.http = http;
      
    }
    /*  
     constructor() {
 
     } */
    ngOnInit() {
        this.forgotPassword = {};
        const email = this._UtilityService.emailForForgotPassword;
        if (email) {
            this.selectedUser = email;
            this.selectedUserPass = this._UtilityService.passwordForForgotPassword;
            this.logintype = this._UtilityService.logintype;
            // console.log("Prefilled email:", this.selectedUser, this.selectedUserPass, this.logintype);
        }
    }


    async goForforgotPassword({ value, valid }) {
        const otpValidityMinutes = 5;
        const now = new Date();
        // console.log("Current time:", this.passkeyGeneratedAt);
        const generatedAt = this.passkeyGeneratedAt;
        if (!generatedAt) {
            this.toastWarningMsg("OTP timestamp missing. Please request a new passkey.");
            return;
        }

        const timeDiff = (now.getTime() - new Date(generatedAt).getTime()) / (1000 * 60); // in minutes
        // console.log("Time difference in minutes:", timeDiff);


        if (this.logintype === 2) {
            if (!this.forgotPassword.passkey) {
                this.toastWarningMsg("Please enter your passkey");
                return;
            }

            if (timeDiff >= otpValidityMinutes) {
                this.toastWarningMsg("OTP expired. Please request a new one.");
                return;
            }

            if (this.forgotPassword.passkey !== this.passkey) {
                this.toastWarningMsg("Invalid passkey entered. Please check your email again.");
                return;
            }

            const updatePayload = {
                email: this.selectedUser,
            };

            this.busy = this.http.post('/api/users/updateuserDetail', updatePayload, { observe: 'response' })
                .subscribe(async (updateResponse) => {
                    const body: any = updateResponse.body;
                    if (body[0].flag === 1) {
                        try {
                            const response = await this.AuthService.login({
                                email: this.selectedUser,
                                password: this.selectedUserPass,
                            });

                            if (response) {
                                setTimeout(() => {
                                    localStorage.setItem('user', JSON.stringify(response));
                                    let data = { user_ID: response._id };
                                    this.AuthService.GetSystemConfigDetails(data);
                                    this._AppServiceService.GetUnitFyearData(response._id);
                                    this.Router.navigateByUrl('/home');
                                }, 500);

                            } else {
                                this.toastWarningMsg("Login failed. Token not received.");
                            }

                        } catch (err) {
                            this.toastWarningMsg(err.error.message || "Login failed after update.");
                        }

                    } else {
                        this.toastWarningMsg("User update failed. Cannot proceed.");
                    }
                }, error => {
                    this.toastWarningMsg("Error updating user before login.");
                });
        } else {
            if (!this.forgotPassword.passkey) {
                this.toastWarningMsg("Please enter your passkey");
                return;
            }

            if (timeDiff >= otpValidityMinutes) {
                this.toastWarningMsg("OTP expired. Please request a new one.");
                return;
            }

            if (this.forgotPassword.passkey !== this.passkey) {
                this.toastWarningMsg("Invalid passkey entered. Please check your email again.");
                return;
            }
            if (this.forgotPassword.passkey == this.passkey) {
                this.Router.navigateByUrl('/resetpassword');
                return;
            }
        }
    }

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg
        });
    };

    passkey: any
    passkeyGeneratedAt : any;
    sendPasskeyEmail(event: Event) {
        event.preventDefault();
        if (!this.selectedUser) {
            this.toastWarningMsg("Please enter your email to send passkey");            
        }
        let payload = {
            "email": this.selectedUser,
            "CompanyId": 1, 
            "UnitId": 1
        }
        this.busy = this.http.post('/api/users/sendPasskeyEmail', payload, { observe: 'response' })
            .subscribe(response => {
                if (response.status == 200) {
                    const body: any = response.body;
                    if (body.error_code === 0) {
                        this.passkey = body.passkey.substring(6, 12);
                        this.passkeyGeneratedAt = new Date();
                        this.toastWarningMsg("Passkey sent to your registered email.");
                    } else {
                        this.toastWarningMsg(body.msg || "No email associated with this username.");
                    }
                } else {
                    this.toastWarningMsg("Error sending passkey email");
                }
            });
    }
}
